exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".react-spinner-loader-svg svg{-webkit-transform-origin:50% 65%;transform-origin:50% 65%}.react-spinner-loader-svg svg polygon{stroke-dasharray:17;-webkit-animation:dash 2.5s cubic-bezier(.35,.04,.63,.95) infinite;animation:dash 2.5s cubic-bezier(.35,.04,.63,.95) infinite}@-webkit-keyframes dash{to{stroke-dashoffset:136}}@keyframes dash{to{stroke-dashoffset:136}}@-webkit-keyframes rotate{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes rotate{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/react-loader-spinner/dist/loader/css/Triangle.css
// module id = 675
// module chunks = 0